import styled from 'styled-components'

const StatusBadgeWrapper = styled.div`
  & > * {
    margin: auto 0;
  }
`

export const s = { StatusBadgeWrapper }
